import { render } from "./AdDocListNav.vue?vue&type=template&id=46a5e5ee&ts=true"
import script from "./AdDocListNav.vue?vue&type=script&lang=ts"
export * from "./AdDocListNav.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__